export const mixin = {
  methods: {
    scrollOnTop: function () {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    breakDateTime: function (datetime) {
      const str = datetime.split('---');
      if (str.length) {
        return `
          <span>${str[0]}</span>
          <br>
          <span>${str[1] ? str[1] : ''}</span>
        `;
      }
      return ''
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixin.js